/* eslint-disable */
var updateLevelDataMaps = function updateLevelDataMaps(levelDataMaps, dataArray, selections, parentItem) {
  dataArray.forEach(function (item) {
    item.subHierarchy = item.subHierarchy || [];
    item.checked = undefined; // important
    item.expanded = undefined;
    item.indeterminate = undefined;
    item.parentNestedId = parentItem === null || parentItem === void 0 ? void 0 : parentItem.nestedId;
    levelDataMaps[item.level].set(item.nestedId, item);
    updateLevelDataMaps(levelDataMaps, item.subHierarchy, selections, item);
  });
};
var getLevelDataMaps = function getLevelDataMaps(dataArray, selectionArray) {
  if (!dataArray || dataArray.length < 1) {
    return null;
  }
  var selections = selectionArray || [];
  var levelDataMaps = [new Map(), new Map(), new Map(), new Map(), new Map()];
  updateLevelDataMaps(levelDataMaps, dataArray, selections);
  return levelDataMaps;
};

export { getLevelDataMaps };
